export const createImagesWithPixelDensity = (image: string, format: string): string[] => [
  image.replace(/\.jpg$/i, `@1.${format} 1x`),
  image.replace(/\.jpg$/i, `@2.${format} 2x`),
  image.replace(/\.jpg$/i, `.${format} 3x`),
]
